import React from 'react';
import PropTypes from 'prop-types';

import List from '@material-ui/core/List';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Separator from '@ublend-npm/aulaui-next-web/Separator';

import { Rectangle, Container } from './Loader.styled';

import { ListItemText, SetListItem } from './ListItem.styled';

import {
  CollapsableContainer,
  TitleBar,
  TitleText,
  ContentContainer,
  ActionsArea,
  FooterContainer,
} from './Collapsable.styled';

const GroupItemLoader = ({ opacity }) => (
  <ListItem
    size="large"
    leftDecoration={
      <React.Fragment>
        <ListItemAvatar>
          <Rectangle width={40} height={40} opacity={opacity - 0.05} />
        </ListItemAvatar>
        <ListItemText
          primary={<Rectangle width={160} height={10} opacity={opacity} />}
          secondary={
            <Rectangle width={120} height={10} opacity={opacity - 0.05} />
          }
        />
      </React.Fragment>
    }
  />
);

GroupItemLoader.propTypes = {
  opacity: PropTypes.number.isRequired,
};

const GroupSetsLoader = () => (
  <List>
    <SetListItem>
      <CollapsableContainer>
        <TitleBar>
          <TitleText>
            <Rectangle width={140} height={12} opacity={0.5} />
          </TitleText>
          <ActionsArea>
            <Container>
              <Rectangle width={24} height={24} opacity={0.4} />
            </Container>
            <Container>
              <Rectangle width={24} height={24} opacity={0.5} />
            </Container>
          </ActionsArea>
        </TitleBar>
        <ContentContainer>
          <List>
            <GroupItemLoader opacity={0.6} />
            <Separator />
            <GroupItemLoader opacity={0.5} />
            <Separator />
            <GroupItemLoader opacity={0.4} />
            <Separator />
            <GroupItemLoader opacity={0.3} />
          </List>
        </ContentContainer>
        <FooterContainer>
          <Container>
            <Container>
              <Rectangle width={20} height={20} opacity={0.5} />
            </Container>
            <Container>
              <Rectangle width={110} height={10} opacity={0.5} />
            </Container>
          </Container>
        </FooterContainer>
      </CollapsableContainer>
    </SetListItem>
  </List>
);

export default GroupSetsLoader;
